import useGetQrCode from "../../hooks/useGetQrCode";

const QrCode = () => {
  const { source } = useGetQrCode();

  return <img src={source} alt="qr-code" />;
};

export default QrCode;
